import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'QUITUS_OPER',
  title: 'Che cos\'è il File Operazioni ?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Il File Operazioni è la sintesi della tua cartella per una data operazione. Indica lo stato dei documenti richiesti per questa operazione. Sostituisce i numerosi documenti obbligatori da fornire al momento della firma e semplifica quindi i vostri scambi con i partner. È possibile consultare i documenti necessari per un\'operazione. Per questo:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Dalla scheda Operazioni, fare clic sull\'operazione'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_QUITUS_OPER/IT_QUITUS_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Clicca sui 3 punti in alto a destra'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_QUITUS_OPER/IT_QUITUS_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Poi su «Vedere i documenti richiesti»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_QUITUS_OPER/IT_QUITUS_OPER_3.png`
  }]
};
